import { z } from "zod";
import { SerialKillerStatusZ } from "./enums/serial-killer-status";

export const SerialKillerListItemDTOz = z
  .object({
    id: z.string(),
    name: z.string(),
    alias: z.string().nullable(),
    status: SerialKillerStatusZ.nullable(),
    numberOfVictims: z.number().int().nonnegative().nullable(),
    activeYearStart: z.number().int().nonnegative().nullable(),
    activeYearEnd: z.number().int().nonnegative().nullable(),
  })
  .strict();
export type SerialKillerListItemDTO = z.infer<typeof SerialKillerListItemDTOz>;

export const SerialKillerDTOz = z
  .object({
    id: z.string(),
    name: z.string(),
    alias: z.string().nullable(),
    pictureLink: z.string().url().nullable(),
    dateOfBirth: z.string().datetime().nullable(),
    placeOfBirth: z.string().nullable(),
    numberOfVictims: z.number().int().nonnegative().nullable(),
    status: SerialKillerStatusZ.nullable(),
    activeYearStart: z.number().int().nonnegative().nullable(),
    activeYearEnd: z.number().int().nonnegative().nullable(),
    dateOfDeath: z.string().datetime().nullable(),
    dateOfArrest: z.string().datetime().nullable(),
    placeOfArrest: z.string().nullable(),
    spanOfCrime: z.string().nullable(),
    penalty: z.string().nullable(),
    placeOfPenalty: z.string().nullable(),
    wikipediaLink: z.string().url().nullable(),
  })
  .strict();
export type SerialKillerDTO = z.infer<typeof SerialKillerDTOz>;